export default class UtilsHelper {
	public static readonly NameRegExp =
		"^[a-zA-ZÀ-ÿĳĲ0-9_]+( [a-zA-ZÀ-ÿĳĲ0-9_]+)*$";
	public static readonly GuidRegExp =
		/^($|[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})$/g;
	public static readonly PhoneNumberRegExp = /^($|\+?(\d+))$/g;
	public static readonly OnlyDigits = /^[0-9]*$/;
	public static readonly PositiveIntegerOrEmpty = /^$|^[1-9][0-9]*$/;
	public static readonly CallbackToneKeyRegEx = /^[0-9*]*$/;
	public static readonly EmailRegExp: RegExp =
		/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9_](?:[a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?(?:\.[a-zA-Z0-9_](?:[a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?)*$/;

	public static readonly EmailFolderRegex =
		/^(?!.*[\\:*"<>\|])([^\\:\/*"<>\|]+(\s+[^\\:\/*"<>\|]+)*)(\/([^\\:\/*"<>\|]+(\s+[^\\:\/*"<>\|]+)*))?$/;

	public static readonly HexColorRegExp =
		/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
	public static readonly HexColorNoHashRegExp =
		/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

	public static getInitials = (name = ""): string => {
		return name
			.replace(/\s+/, " ")
			.split(" ")
			.slice(0, 2)
			.map((v) => v && v[0].toUpperCase())
			.join("");
	};

	public static areArraysEqual = (arr1, arr2) => {
		if (arr1.length !== arr2.length) {
			return false;
		}

		return arr1.every((value, index) => value === arr2[index]);
	};

	public static mapToTokenArray = (stringArray: string[]) => {
		return stringArray.map((item) => ({
			value: `{${item}}`,
		}));
	};

	public static pascalToCamel(str: string): string {
		if (!str) {
			return "";
		}
    
		return str[0].toLowerCase() + str.slice(1);
	}

	public static camelToPascal(str: string): string {
		if (!str) {
			return "";
		}
    
		return str[0].toUpperCase() + str.slice(1);
	}
}
